// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FullscreenOutlinedSvg from "@fishx/icons-svg/es/asn/FullscreenOutlined";
import FishxIcon from '../components/FishxIcon';

var FullscreenOutlined = function FullscreenOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FullscreenOutlinedSvg
  }));
};

FullscreenOutlined.displayName = 'FullscreenOutlined';
export default React.forwardRef(FullscreenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FullscreenOutlined.js
// module id = 2844
// module chunks = 0